// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f2c89da7","732":"73718a69","977":"2d35a221"}[chunkId] + ".chunk.js";
};